module.exports = __webpack_public_path__ + "img/hk_nika.c8abe71b.png";